import React from 'react';
import Link from 'next/link';
import styles from './Button.module.css';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
  as?: 'button' | 'a';
  href?: string;
}

/**
 * Reusable Button Component
 * Single source of truth for all button styling
 * Can render as button or link
 */
export function Button({
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  as = 'button',
  href,
  ...props
}: ButtonProps) {
  const classNames = [
    styles.button,
    styles[variant],
    styles[size],
    className,
  ].filter(Boolean).join(' ');

  if (as === 'a' && href) {
    // Internal link
    if (href.startsWith('/')) {
      return (
        <Link href={href} className={classNames}>
          {children}
        </Link>
      );
    }
    // External link
    return (
      <a href={href} className={classNames} {...props as any}>
        {children}
      </a>
    );
  }

  return (
    <button className={classNames} {...props}>
      {children}
    </button>
  );
}
